export default __webpack_public_path__ + "static/media/logo-tud.d9b22ed2.svg";